import { Component, Input } from '@angular/core'
import { MbConstants } from '../../../mb-constants'

@Component({
  selector: 'mb-empty-address-tile',
  templateUrl: './mb-empty-address-tile.component.html',
  styleUrls: ['./mb-empty-address-tile.component.scss']
})
export class MbEmptyAddressTileComponent {

  @Input() headline: String = ''
  @Input() message: String = ''
  @Input() link: String = ''
  @Input() linkText: String = ''

  readonly allProductCategoriesUrl = MbConstants.ALL_PRODUCT_CATEGORIES_URL
}
